module.exports = __webpack_public_path__ + "img/tyg_solution1.a473f900.png";